import React from "react";
import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";

function StyledTabIconBox({ children }) {
  const theme = useTheme();

  return (
    <Box
      sx={{
        width: "50px",
        height: "50px",
        "& .MuiSvgIcon-root": {
          width: "30px",
          height: "30px",
        },
        [theme.breakpoints.down("laptop")]: {
          width: "80%",
          height: "80%",
          margin: "auto",
          maxWidth: "76px",
          maxHeight: "76px",
        },
      }}
    >
      {children}
    </Box>
  );
}

export default React.memo(StyledTabIconBox);
